export const TERMS_AND_CONDITIONS_VERSION = 1;
